/**
 * Ela Teila custom JavaScript.
 */

/* RestockRocket "Notify me" popup brand tweaks. */
(function () {
  function applyTweaks() {
    document.querySelectorAll('.restock-rocket-wrapper select').forEach(function (s) {
      s.style.setProperty('background-color', '#eef1f4', 'important');
    });
    document.querySelectorAll('.restock-rocket-wrapper input').forEach(function (i) {
      if (i.type === 'email' || i.type === 'text' || i.getAttribute('placeholder')) {
        if (i.getAttribute('placeholder') !== 'Your e-mail') {
          i.setAttribute('placeholder', 'Your e-mail');
        }
        if (i.style.fontSize !== '13px') {
          i.style.setProperty('font-size', '13px', 'important');
        }
      }
    });
  }
  function start() {
    applyTweaks();
    var observer = new MutationObserver(function () { applyTweaks(); });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* Ela Teila: gift card recipient brand fonts, 1px active borders, autofill styling,
   and gift-card-product-only layout fixes. */
(function () {
  var css = ".gift-card-recipient .input__field,.gift-card-recipient .input__label{font-family:'Roboto Condensed',sans-serif !important;letter-spacing:0.5px !important}"
    + ".gift-card-recipient .input__field{color:#404f61 !important;border-width:1px !important}"
    + ".input__field:focus,.input:focus-within .input__field{border-color:#404f61 !important;border-width:1px !important;box-shadow:none !important;outline:none !important}"
    + ".block-swatch__radio:checked + .block-swatch__item,.block-swatch__item.is-selected{border:1px solid #404f61 !important;box-shadow:none !important}"
    + ".block-swatch__radio:checked + .block-swatch__item:after,.block-swatch__item.is-selected:after{box-shadow:none !important}"
    + ".input__field:-webkit-autofill,.input__field:-webkit-autofill:hover,.input__field:-webkit-autofill:focus{-webkit-text-fill-color:#404f61 !important;caret-color:#404f61 !important;-webkit-box-shadow:0 0 0 1000px #eef1f4 inset !important;box-shadow:0 0 0 1000px #eef1f4 inset !important}"
    + ".et-gc .product__zoom-button{display:none !important}"
    + ".et-gc .product__media-image-wrapper.aspect-ratio{aspect-ratio:27 / 25 !important}"
    + ".et-gc .product__media-image-wrapper.aspect-ratio img{object-fit:cover !important;object-position:top center !important}";
  var s = document.createElement('style');
  s.setAttribute('data-et-giftcard', '');
  s.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(s);
  function flagGiftCard() {
    if (location.pathname.indexOf('/products/ela-teila-gift-card') !== -1) {
      document.documentElement.classList.add('et-gc');
    } else {
      document.documentElement.classList.remove('et-gc');
    }
  }
  flagGiftCard();
  document.addEventListener('DOMContentLoaded', flagGiftCard);
})();

/* Ela Teila: on the cart page, (1) move the shipping estimator into the summary
   card (below payments), and (2) move its ESTIMATE submit button INTO the
   input-row so it can sit next to the Zip code field (see custom-cart.css grid).
   Idempotent + re-runnable (cart quantity links reload the page). */
(function () {
  function arrangeEstimator() {
    if (!document.documentElement.classList.contains('template--cart')) return;
    var est = document.querySelector('.shipping-estimator');
    var inner = document.querySelector('.cart__aside-inner');
    if (est && inner && !est.closest('.cart__aside-inner')) {
      inner.appendChild(est);
    }
    var row = document.querySelector('.shipping-estimator .input-row');
    var submit = document.querySelector('.shipping-estimator .form__submit');
    if (row && submit && submit.parentElement !== row) {
      row.appendChild(submit);
    }
  }
  function run() {
    arrangeEstimator();
    var mo = new MutationObserver(function () { arrangeEstimator(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* Ela Teila: carry the selected SIZE + SCROLL position across colour switches,
   and make the switch feel smooth. Colours are separate products, so a colour
   click is a full navigation. This block: (1) on click, remembers the selected
   size + scroll position and loads the matching variant on the target colour
   via ?variant=; (2) on the destination page, runs ASAP to HIDE the page,
   restore the scroll position, then reveal — so there is no visible jump/flash.
   Site-wide on product pages; degrades to normal navigation on any failure. */
(function () {
  var SS_KEY = 'etColorSwitch';

  /* --- runs immediately when this deferred script executes (before DCL) --- */
  var pending = null;
  try {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var raw0 = sessionStorage.getItem(SS_KEY);
    if (raw0) {
      var d0 = JSON.parse(raw0);
      if (d0 && (Date.now() - d0.t) < 10000 && typeof d0.y === 'number' && location.pathname.indexOf('/products/') !== -1) {
        pending = d0;
      }
    }
  } catch (e) {}
  var docEl = document.documentElement;
  var revealTimer = null;
  function reveal() {
    if (!pending) return;
    try { docEl.style.visibility = ''; } catch (e) {}
    if (revealTimer) { clearTimeout(revealTimer); revealTimer = null; }
  }
  if (pending) {
    try { docEl.style.visibility = 'hidden'; } catch (e) {}
    revealTimer = setTimeout(function () { try { docEl.style.visibility = ''; } catch (e) {} }, 1500);
  }

  function currentSize() {
    var sel = null;
    document.querySelectorAll('.product-form__option-selector').forEach(function (s) {
      var n = s.querySelector('.product-form__option-name');
      if (n && /size/i.test(n.textContent)) sel = s;
    });
    if (!sel) return null;
    var active = sel.querySelector('.combo-box__option-item[aria-selected="true"]');
    if (active) return active.textContent.trim();
    var checked = sel.querySelector('.block-swatch__radio:checked, input[type="radio"]:checked');
    if (checked) {
      var lbl = sel.querySelector('label[for="' + checked.id + '"]') || sel.querySelector('.block-swatch__item');
      var full = lbl ? (lbl.getAttribute('data-et-full') || lbl.textContent.trim()) : null;
      return full ? full.split('·')[0].trim() : null;
    }
    var native = sel.querySelector('select');
    if (native && native.selectedOptions[0]) return native.selectedOptions[0].textContent.trim();
    return null;
  }

  function onColorClick(e, link) {
    var href = link.getAttribute('href');
    if (!href) return;
    var size = currentSize();
    try { sessionStorage.setItem(SS_KEY, JSON.stringify({ y: window.scrollY, size: size, t: Date.now() })); } catch (err) {}
    if (!size) return; // navigate normally; scroll is still restored on load
    e.preventDefault();
    var base = href.split('?')[0];
    var done = false;
    function go(url) { if (!done) { done = true; window.location.href = url; } }
    var timer = setTimeout(function () { go(href); }, 1000);
    fetch(base + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var match = p.variants.filter(function (x) { return x.available; }).find(function (x) { return x.options.indexOf(size) !== -1; })
                || p.variants.find(function (x) { return x.options.indexOf(size) !== -1; });
      clearTimeout(timer);
      go(match ? (base + '?variant=' + match.id) : href);
    }).catch(function () { clearTimeout(timer); go(href); });
  }

  function bind() {
    document.querySelectorAll('.et-color-switch__item[href]').forEach(function (link) {
      if (link.getAttribute('data-et-cs')) return;
      link.setAttribute('data-et-cs', '1');
      link.addEventListener('click', function (e) { onColorClick(e, link); });
    });
  }

  function restore() {
    if (!pending) return;
    try { sessionStorage.removeItem(SS_KEY); } catch (e) {}
    var y = pending.y;
    window.scrollTo(0, y);
    requestAnimationFrame(function () { window.scrollTo(0, y); reveal(); });
    setTimeout(function () { window.scrollTo(0, y); }, 200);
    setTimeout(reveal, 400);
  }

  function start() {
    restore();
    bind();
    var mo = new MutationObserver(function () { bind(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();

/* Ela Teila: give the STOQ "Notify me when available" button the SAME hover
   effect as ADD TO CART — a gentle darken sweeping up from the BOTTOM on hover —
   keeping its own colour (#404f61). Uses a doubled-height two-tone background
   whose position animates on hover. Selectors are doubled-up for specificity so
   they beat the STOQ app's own "background-image:none". Site-wide. */
(function () {
  var css =
    '.restock-rocket-button.restock-rocket-button,' +
    '.restock-rocket-button-product.restock-rocket-button-product{' +
      'background-color:#404f61 !important;' +
      'background-image:linear-gradient(to top, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.15) 50%, rgba(0,0,0,0) 50%, rgba(0,0,0,0) 100%) !important;' +
      'background-size:100% 200% !important;' +
      'background-position:0% 0% !important;' +
      'background-repeat:no-repeat !important;' +
      'transition:background-position 0.3s cubic-bezier(0.215,0.61,0.355,1) !important;}' +
    '.restock-rocket-button.restock-rocket-button:hover,' +
    '.restock-rocket-button-product.restock-rocket-button-product:hover{' +
      'background-position:0% 100% !important;}';
  var el = document.createElement('style');
  el.setAttribute('data-et-notify', '');
  el.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(el);
})();
